// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"4c031862","233":"62da2dc6","325":"ad65f299","795":"9bf2e2b1","805":"cd9d49c4"}[chunkId] + ".chunk.js";
};